import request from "@/utils/request";

export function getDigests(params) {
  return request({
    url: "/api/admin/digest/",
    method: "get",
    params,
  });
}

export function getDigestID(id) {
  return request({
    url: `/api/admin/digest/${id}/`,
    method: "get",
  });
}

export function postDigest(data) {
  return request({
    url: "/api/admin/digest/",
    method: "post",
    data,
  });
}

export function patchDigest(id, data) {
  return request({
    url: `/api/admin/digest/${id}/`,
    method: "patch",
    data,
  });
}
